<style scoped>
  .project-item{
    display: flex;
    padding: 15px;
    background: #fff;
    border-bottom: 1px solid #eee;
    /* align-items: center; */
  }
  .project-image {
    width: 100px;
    height: 100px;
    background: #eee;
    margin-right: 10px;
  }
  .project-info {
    margin-right: 10px;
  }
</style>

<template>
  <div class="special-project-single">
    <div class="project-container">
      <div class="project-item" v-for="index in 10" :key="index">
        <!-- <div class="project-image">

        </div> -->
        <Avatar shape="square" icon="person" size="large" style="margin-right: 15px;" />
        <div class="project-info">
          <h3>Title</h3>
          <p>Lorem ipsum dolor sit amet.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SpecialProjectSingleComponent',
  }
</script>

